import { render, staticRenderFns } from "./orderReport.vue?vue&type=template&id=8c175666&scoped=true&lang=pug&"
import script from "./orderReport.vue?vue&type=script&lang=js&"
export * from "./orderReport.vue?vue&type=script&lang=js&"
import style0 from "./orderReport.vue?vue&type=style&index=0&id=8c175666&prod&lang=sass&"
import style1 from "./orderReport.vue?vue&type=style&index=1&id=8c175666&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c175666",
  null
  
)

export default component.exports